import React from 'react';
import PropTypes from 'prop-types';

const capitalize = str =>
  str
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());

const RenderChange = ({ data, tab = 0 }) => {
  if (!data || typeof data !== 'object') return null;

  return (
    <div style={{ marginLeft: tab * 16 }}>
      {Object.entries(data).map(([key, value]) => {
        // Check if this is a simple attribute change (has old/new)
        if (value.old !== undefined || value.new !== undefined) {
          const displayOld = value.old_formatted !== undefined ? value.old_formatted : value.old;
          const displayNew = value.new_formatted !== undefined ? value.new_formatted : value.new;
          const attributeLabel = value.label || capitalize(key);

          return (
            <div key={key} style={{ marginBottom: 8 }}>
              <strong>{attributeLabel}</strong>: <i>{displayOld}</i> → <i>{displayNew}</i>
            </div>
          );
        }

        // Check if this has a nested structure with label and changes
        const { label, added, removed, message, changes } = value;

        return (
          <div key={key} style={{ marginBottom: 12 }}>
            {label && (
              <div style={{ marginBottom: 4 }}>
                <strong>{label}</strong>
                {message && <i style={{ marginLeft: 8 }}>{message}</i>}
              </div>
            )}

            {added && added.length > 0 && (
              <div style={{ marginLeft: 16 }}>
                <strong>Added:</strong>
                {added.map((item, index) => (
                  <div key={`added-${index}`} style={{ marginLeft: 8 }}>
                    • {item}
                  </div>
                ))}
              </div>
            )}

            {removed && removed.length > 0 && (
              <div style={{ marginLeft: 16 }}>
                <strong>Removed:</strong>
                {removed.map((item, index) => (
                  <div key={`removed-${index}`} style={{ marginLeft: 8 }}>
                    • {item}
                  </div>
                ))}
              </div>
            )}

            {changes && Object.keys(changes).length > 0 && (
              <div style={{ marginLeft: 16 }}>
                <RenderChange data={changes} tab={0} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

RenderChange.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  tab: PropTypes.number
};

RenderChange.defaultProps = {
  tab: 0
};

const Main = ({ item }) => {
  if (!item) return <div>No changes</div>;

  return <RenderChange data={item} tab={0} />;
};

Main.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired
};

export default Main;
